import { Collection } from 'modules/core/lib/mobx-rest'

import ApplicationPhase from 'modules/ats/store/models/ApplicationPhase'

class ApplicationPhases extends Collection<ApplicationPhase> {
  get cacheKey(): string {
    return 'applicationPhases'
  }

  model() {
    return ApplicationPhase
  }
}

const singleton: ApplicationPhases = new ApplicationPhases()

export default singleton
